import PresetPage from 'domain/entity/preset/presetPage/presetPage';
import getGenericUseCase from 'use-case/genericUseCase';
import ReadPresetPageCriteria from 'use-case/presets/presetPage/read/readPresetPageCriteria';

const getReadPresetPageUseCase = getGenericUseCase<PresetPage, ReadPresetPageCriteria>((client, criteria) => client(criteria));

export default getReadPresetPageUseCase;
